import React from 'react'
import styled from 'styled-components';
import useLogin from '../providers/use_login';
import { Form, Button } from 'react-bootstrap';
import Loading from './loading';

const Frame = styled.div`
  margin-right: auto;
  margin-left: auto;
  max-width: 400px;
  `;

const activo = true;

const Register = ({onSuccess, style}) => {
  const {register, error, isReady, isBusy} = useLogin()

  if (!isReady) return <Loading />

  if (!activo) return (<Frame>
      <p>Los registros están cerrados en este momento.</p>
    </Frame>)

  return (
    <Frame style={{...style}}>
      <p>Las cuentas de la Biblioteca requieren activación por parte de la Administración. Contacta a un <strong>Admin</strong> mediante Discord o Mensaje Personal en el foro.</p>
      <p>Su finalidad es poder crear propuestas de edición. No se requiere de cuenta para consultar la información.</p>
      <p>Sólo se autorizará a aquellos que lleven al menos un mes roleando en el foro y conozcan el lore.</p>
      <Form onSubmit={(e) => {
        e.preventDefault()
        register(e.target.elements.displayName.value, e.target.elements.email.value, e.target.elements.password.value, onSuccess)
      }}>
        <Form.Group controlId="displayName">
          <Form.Label>Nombre de Usuario</Form.Label>
          <Form.Control disabled={isBusy} type="text" required placeholder="Nombre de Usuario en el Foro" />
          <Form.Text className="text-muted">
            Debe ser el mismo usuario que usas en el Foro. Se confirmará mediante Discord o MP.
          </Form.Text>
        </Form.Group>

        <Form.Group controlId="email">
          <Form.Label>Correo Electrónico</Form.Label>
          <Form.Control disabled={isBusy} type="text" required placeholder="Correo Electrónico" />
          <Form.Text className="text-muted">
            Se recomienda que sea el mismo que usas para el foro, pero no es obligatorio.
          </Form.Text>
        </Form.Group>

        <Form.Group controlId="password">
          <Form.Label>Contraseña</Form.Label>
          <Form.Control disabled={isBusy} type="password" required placeholder="Contraseña" />
          <Form.Text className="text-muted">
            NO es necesario que sea la misma del foro.
          </Form.Text>
          <Form.Text className="text-muted">
            {error
            ? <span style={{color: 'red'}}>{error}</span>
            : ''}
          </Form.Text>
        </Form.Group>
        {/* <Form.Group controlId="formBasicCheckbox">
          <Form.Check type="checkbox" label="Check me out" />
        </Form.Group> */}
        <Button disabled={isBusy || !isReady} variant="primary" type="submit">
          Registrarse
        </Button>
        <br />
        <br />
        <p>Nota: Si necesitas reestablecer tu contraseña, contacta a la administración.</p>
      </Form>
    </Frame>
  );
};

export default Register